import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

export const NavLink: React.FC<{
    href?: string,
    id?:string,
    style?: React.CSSProperties,
    children: React.ReactNode
}> = ({ href, children, style,id }) => {

    const router = useRouter();

    // function getAnchorClassNames() {
    //     if (href) {
    //         if (href === '/') {
    //             if (router.pathname === '/') {
    //                 return 'text-defaultBlue';
    //             }
    //         } else if (router.pathname.startsWith(href)) {
    //             return 'text-defaultBlue';
    //         }
    //     }
    //     if(id == 'footerList'){
    //         return 'text-black'
    //     }
    //     return 'text-gray-500';
    // }

    function getAnchorClassNames() {
        const current = router.asPath; // supaya bisa membaca hash

        // Jika link punya hash
        if (href && href.includes("#")) {
            if (current === href) {
                return "text-defaultBlue";
            }
            return id === "footerList" ? "text-black" : "text-gray-500";
        }

        // Special case: HOME ('/')
        if (href === "/") {
            // Home aktif hanya kalau EXACT `/`
            if (current === "/") {
                return "text-defaultBlue";
            }
            return id === "footerList" ? "text-black" : "text-gray-500";
        }

        // Link tanpa hash -> pakai prefix match
        if (href && current.startsWith(href)) {
            return "text-defaultBlue";
        }

        return id === "footerList" ? "text-black" : "text-gray-500";
    }


    return (
        <Link href={href ?? '#'} className={getAnchorClassNames()} style={style}>
            {children}
        </Link>
    );
}
